
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Lock, Zap } from 'lucide-react';
import { useUnifiedAuth } from '@/contexts/auth/UnifiedAuthProvider';
import { AuthSecurityValidator } from '@/lib/auth-security';
import { shouldShowUpgradePrompt } from '@/lib/subscription-utils';

interface SubscriptionGateProps {
  feature: string;
  featureName: string;
  description: string;
  children: React.ReactNode;
}

export function SubscriptionGate({ feature, featureName, description, children }: SubscriptionGateProps) {
  const { user, subscriptionTier } = useUnifiedAuth();
  
  
  // Check if user should see upgrade prompt
  if (shouldShowUpgradePrompt(subscriptionTier, feature)) {
    return (
      <Card data-testid="subscription-gate" className="mx-auto max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-orange-100">
            <Lock className="h-6 w-6 text-orange-600" />
          </div>
          <CardTitle className="text-xl">Premium Feature</CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-4">
          <div>
            <h3 className="font-semibold text-lg mb-2">{featureName}</h3>
            <p className="text-muted-foreground">{description}</p>
          </div>
          
          <Button className="w-full" size="lg" onClick={() => (window.location.href = '/subscription')}>
            <Zap className="mr-2 h-4 w-4" />
            Upgrade to Premium
          </Button>
          
          <p className="text-xs text-muted-foreground">
            Unlock unlimited access to all coaching features
          </p>
        </CardContent>
      </Card>
    );
  }
  
  // User has access, render children
  return <>{children}</>;
}
